import Cookies from 'js-cookie';
import { store } from '@/store';

const authMiddleware = async (to, from, next) => {
    const token = Cookies.get('x-access-token');

    if (!token) {
        return next({ name: 'login', query: { referral: to.fullPath } });
    }

    try {
        const res = await window.axios.get('/user', {
            headers: { Authorization: `Bearer ${token}` }
        });

        const user = res.data.user;
        const role = res.data.role.role;

        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        store.dispatch('setIsLoggedIn', true);
        store.dispatch('setUser', user);
        store.dispatch('setRole', role);

        next();
    } catch (e) {
        next({ name: 'login', query: { referral: to.fullPath } });
    }
};

export default authMiddleware;